import { render, staticRenderFns } from "./VehiclePriceSetModal.vue?vue&type=template&id=5e494213&"
import script from "./VehiclePriceSetModal.vue?vue&type=script&lang=js&"
export * from "./VehiclePriceSetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports